export type { ProductType } from './product-type-card'
export { default as ProductTypeCard } from './product-type-card'
